import React, { Component } from 'react';
import { EmptyState } from '../../commons';
import { Table, Toast, Label } from '../../../UiKit';
import { InvalidSearchImg, upArrowIcon } from '../../../images/images';
import Switch from 'sushiweb/Switch';
import { agentActionsModel } from '../../../api';
import Shimmer from 'sushiweb/Shimmer';
import {
  KEBAB_MENU_EVENTS,
  sendKebabMenuEvents,
} from '../../../helpers/analytics/kebabMenu.analytics';

const dashboardMode = window.dashboard.mode;
const DASHBOARD_SMARTPLUG = 'smartplug';
const HIGH_PRIORITY = 'high';
const LOW_PRIORITY = 'low';
const TICKET_STATUS_CLOSED = 'Closed';

const tableHeadings = [
  { name: 'Ticket ID', key: 1 },
  { name: 'Order ID', key: 2 },
  { name: 'Details', key: 3 },
  { name: 'Assignee', key: 4 },
  { name: 'High Priority', key: 5 },
];

const smartplugTableHeadings = [
  { name: 'Ticket ID', key: 1 },
  { name: 'Order ID', key: 2 },
  { name: 'Details', key: 3 },
  { name: 'High Priority', key: 4 },
];

const tdMaxWidth = ['18.1rem', '14rem', '20rem', '14rem', '14rem'];
const tdMaxWidthSmartplug = ['14rem', '14rem', '18.5rem', '14rem'];

export default class UserEscalations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: null,
      error: false,
      errorMessage: '',
      toggleCount: 0,
      showTagToast: false,
      toastTagText: '',
      toastTagType: 'success',
    };
  }

  componentDidMount = () => {
    this.getEmailEscalations();
  };

  getEmailEscalations = () => {
    const { orderId, isNewUser, userId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    if (isNewUser) {
      queryStrings['user_id'] = userId;
    }

    agentActionsModel
      .getEmailEscalations(queryStrings)
      .then((response) => {
        if (!response || (response && response.isError)) {
          sendKebabMenuEvents(
            KEBAB_MENU_EVENTS.GET_USER_ESCALATION_DETAILS_FAILURE,
            orderId,
            userId,
          );
          this.setState({
            error: true,
            errorMessage:
              response.message || 'Something went wrong! Please try again!',
          });
          return;
        }
        const { all_tickets } = response;
        const tickets = Object.values(all_tickets);
        sendKebabMenuEvents(
          KEBAB_MENU_EVENTS.GET_USER_ESCALATION_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setState({
          tickets: tickets,
        });
      })
      .catch(() => {
        sendKebabMenuEvents(
          KEBAB_MENU_EVENTS.GET_USER_ESCALATION_DETAILS_FAILURE,
          orderId,
          userId,
        );
        this.setState({
          error: true,
          errorMessage: 'Something went wrong! Please try again!',
        });
      });
  };

  getRowsData = (tickets) => {
    const rowsData = [];
    tickets &&
      tickets.map((ticket) => {
        const { ticket_info } = ticket;
        const firstColumnData = {
          title:
            (
              <p>
                {ticket_info.ticket_number}
                <span className='iconMarginL large'>
                  <a
                    className='icon'
                    href={ticket_info.url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={upArrowIcon} alt='' />
                  </a>
                </span>
              </p>
            ) || '-',
          subtitle:
            (
              <div>
                <p>{ticket_info.ticket_timestamp}</p>
                {ticket_info?.status && (
                  <p className='mt10'>
                    <Label
                      title={ticket_info.status.string}
                      bgColor={ticket_info.status.bg_color}
                      textColor={ticket_info.status.color}
                    />
                  </p>
                )}
              </div>
            ) || '-',
        };
        let obj;
        if (dashboardMode === DASHBOARD_SMARTPLUG) {
          obj = {
            1: {
              title: firstColumnData['title'],
              subtitle: firstColumnData['subtitle'],
            },
            2: {
              title: ticket.order_id || '-',
            },
            3: {
              title: ticket_info.details || '-',
            },
            4: {
              title:
                this.checkPriority(
                  ticket_info.ticket_id,
                  ticket_info.priority,
                  ticket_info.status.string,
                ) || '-',
            },
          };
        } else {
          obj = {
            1: {
              title: firstColumnData['title'],
              subtitle: firstColumnData['subtitle'],
            },
            2: {
              title: ticket.order_id || '-',
            },
            3: {
              title: ticket_info.details || '-',
            },
            4: {
              title: ticket_info.assignee || '-',
            },
            5: {
              title:
                this.checkPriority(
                  ticket_info.ticket_id,
                  ticket_info.priority,
                  ticket_info.status.string,
                ) || '-',
            },
          };
        }
        rowsData.push(obj);
        return true;
      });
    return rowsData;
  };

  getTableData = (tickets) => {
    if (!tickets) return null;
    let headings =
      dashboardMode === DASHBOARD_SMARTPLUG
        ? smartplugTableHeadings
        : tableHeadings;
    const tableData = {
      headings: headings,
      rows: this.getRowsData(tickets),
    };
    return tableData;
  };

  closeTagToast = () => {
    this.setState({
      showTagToast: false,
    });
  };

  changePriority = (activeState, ticketId) => {
    this.setState(
      (state) => {
        return {
          toggleCount: state.toggleCount + 1,
        };
      },
      () => {
        const { tickets } = this.state;
        const { orderId, userId, isNewUser } = this.props;
        if (this.state.toggleCount <= tickets.length) {
          return;
        }
        const data = {};
        data['ticket_id'] = ticketId;
        data['new_priority'] = activeState ? HIGH_PRIORITY : LOW_PRIORITY;
        if (isNewUser) {
          data['user_id'] = userId;
        }
        agentActionsModel
          .changeTicketPriority(data)
          .then((response) => {
            if (!response.isError) {
              sendKebabMenuEvents(
                KEBAB_MENU_EVENTS.CHANGE_USER_ESCALATION_PRIORITY_FAILURE,
                orderId,
                userId,
              );
              this.setState({
                showTagToast: true,
                toastTagText: 'Updated priority successfully!',
                toastTagType: 'success',
              });
            } else {
              sendKebabMenuEvents(
                KEBAB_MENU_EVENTS.CHANGE_USER_ESCALATION_PRIORITY_SUCCESS,
                orderId,
                userId,
              );
              this.setState({
                showTagToast: true,
                toastTagText: response.message,
                toastTagType: 'error',
              });
            }
          })
          .catch((error) => {
            sendKebabMenuEvents(
              KEBAB_MENU_EVENTS.CHANGE_USER_ESCALATION_PRIORITY_FAILURE,
              orderId,
              userId,
            );
            this.setState({
              showTagToast: true,
              toastTagText: 'Ooopss! Something went wrong!',
              toastTagType: 'error',
            });
          });
      },
    );
  };

  showClosedTicketAlert(status) {
    if (status === TICKET_STATUS_CLOSED) {
      this.setState({
        showTagToast: true,
        toastTagText: 'Can not update priority of a closed ticket!',
        toastTagType: 'error',
      });
    }
  }

  checkPriority = (ticketId, priority, status) => {
    return (
      <Switch
        readOnly={status === TICKET_STATUS_CLOSED}
        color='#3AB757'
        active={priority === HIGH_PRIORITY}
        onToggle={(activeState) => this.changePriority(activeState, ticketId)}
        onClick={() => this.showClosedTicketAlert(status)}
      />
    );
  };

  render() {
    const { tickets, error, errorMessage } = this.state;
    if (!tickets && !error) {
      return <Shimmer height='300px' width='100%' />;
    }
    if (error) {
      return (
        <EmptyState
          img={InvalidSearchImg}
          heading={errorMessage}
          isPop={true}
        />
      );
    }
    const { showTagToast, toastTagText, toastTagType } = this.state;
    return (
      <div>
        <Toast
          show={showTagToast}
          align='top'
          text={toastTagText}
          type={toastTagType}
          onClose={this.closeTagToast}
        />
        <div className='modalContent'>
          {tickets.length === 0 ? (
            <EmptyState
              img={InvalidSearchImg}
              heading='No escalations found.'
              isPop={true}
            />
          ) : dashboardMode === DASHBOARD_SMARTPLUG ? (
            <Table
              tableData={this.getTableData(tickets)}
              tdMaxWidth={tdMaxWidthSmartplug}
            />
          ) : (
            <Table
              tableData={this.getTableData(tickets)}
              tdMaxWidth={tdMaxWidth}
            />
          )}
        </div>
      </div>
    );
  }
}
